import React, { useContext } from 'react';

export const MessagingV2Context = React.createContext(false);

export const useIsMessagingV2 = () => useContext(MessagingV2Context);
